import {
  InputMelFinal,
  InputAjustCaldoVazaoDest,
  InputSeletora,
} from "../fixedCurrents";

const LogicDistilleryAndFactory = {
  Apply(inputsToSend) {
    try {
      let i_1_500 = InputSeletora();
      let i_5_100 = InputMelFinal();
      let JTT_701_P_WV = InputAjustCaldoVazaoDest();

      let selectNode = inputsToSend.find((input) => input.isEquals(i_1_500));
      if(!selectNode.index) return 

      let inputMelNode = inputsToSend.find((input) => input.isEquals(i_5_100));
      let InputAjustCaldoVazaoDestNode = inputsToSend.find((input) =>
        input.isEquals(JTT_701_P_WV)
      );

      console.log('Prioridade de produção :>> ', selectNode.value);
      if (selectNode && selectNode.value == "1,00") {
       if(InputAjustCaldoVazaoDestNode) InputAjustCaldoVazaoDestNode.value = "0,01";
      } else {
        if(inputMelNode) inputMelNode.value = "0,00";
      }
    } catch (e) {
      console.warn(
        `Falha ao enviar os dados em LogicDistilleryAndFactory. \nErro: ${e}`
      );
    }
  },
};

export default LogicDistilleryAndFactory;
